<template>
  <div class="card bg-white border-0 rounded-3 mb-4 rounded-3">
    <div class="card-body p-4">
      <h3 class="mb-4">Attachments</h3>

      <div
        class="d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
      >
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <i
              class="ri-file-warning-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle"
            ></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h4 class="mb-1 fs-14 fw-medium">Project_attachment_1.zip</h4>
            <span class="fs-13">3.25 MB</span>
          </div>
        </div>

        <button class="p-0 border-0 bg-transparent">
          <i class="ri-download-2-line fs-22 text-primary"></i>
        </button>
      </div>
      <div
        class="d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
      >
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <i
              class="ri-file-warning-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle"
            ></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h4 class="mb-1 fs-14 fw-medium">Project_attachment_1.zip</h4>
            <span class="fs-13">3.25 MB</span>
          </div>
        </div>

        <button class="p-0 border-0 bg-transparent">
          <i class="ri-download-2-line fs-22 text-primary"></i>
        </button>
      </div>
      <div
        class="d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
      >
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <i
              class="ri-file-warning-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle"
            ></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h4 class="mb-1 fs-14 fw-medium">Project_attachment_1.zip</h4>
            <span class="fs-13">3.25 MB</span>
          </div>
        </div>

        <button class="p-0 border-0 bg-transparent">
          <i class="ri-download-2-line fs-22 text-primary"></i>
        </button>
      </div>
      <div
        class="d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-0"
      >
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <i
              class="ri-file-warning-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle"
            ></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h4 class="mb-1 fs-14 fw-medium">Project_attachment_1.zip</h4>
            <span class="fs-13">3.25 MB</span>
          </div>
        </div>

        <button class="p-0 border-0 bg-transparent">
          <i class="ri-download-2-line fs-22 text-primary"> </i>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Attachments",
});
</script>
